export const colorCode = [
    {
        label:"Black",
        value:"#000000"
    },
    {
        label:"Blue",
        value:"#0000FF"
    },
    
    {
        label:"Green",
        value:"#00FF00"
    },
    
    {
        label:"Red",
        value:"#FF0000"
    },
    
    {
        label:"Cyan",
        value:"#00FFFF"
    },
    
    {
        label:"Magenta",
        value:"#FF00FF"
    },
    
    {
        label:"Yellow",
        value:"#FFFF00"
    },
    {
        label:"White",
        value:"#FFFFFF"
    },
    {
        label:"Orange",
        value:"#FFA500"
    },
    {  
        label:"Dark Green",
        value:"#008000"
    },
    {
        label:"Purple",
        value:"#800080"
    },
    {
        label:"Navy Blue",
        value:"#000080"
    },
    {
        label:"Maroon",
        value:"#800000"
    },
    {
        label:"Teal",
        value:"#008080"
    },
    {
        label:"Olive",
        value:"#808000"
    },
    
    {
        label:"Gray",
        value:"#808080"
    }, 
    {
        label:"Light Gray",
        value:"#C0C0C0"
    },
    {
        label:"Dark Gray",
        value:"#404040"
    },
    
    {
        label:"Pink",
        value:"#FFC0CB"
    },
    {
        label:"Light Blue",
        value:"#ADD8E6"
    },
    {
        label:"Light Green",
        value:"#90EE90"
    },
    
    {
        label:"Brown",
        value:"#A52A2A"
    },
    
    {
        label:"Gold",
        value:"#FFD700"
    },
    {
        label:"Silver",
        value:"#C0C0C0"
    },
    {
        label:"Violet",
        value:"#EE82EE"
    },  
    {
        label:"Indigo",
        value:"#4B0082"
    }
]